import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, filter, map, take } from 'rxjs';
import { InternetConnectionState } from '../model/internet-connection-state';
import { ConnectionType, Network } from '@capacitor/network';

export abstract class NetworkService {
    abstract get internet$(): Observable<InternetConnectionState>;
    abstract waitForInternetConnection(): Observable<void>;
}

@Injectable()
export class MobileNetworkService extends NetworkService {
    private _internetSubject = new ReplaySubject<InternetConnectionState>(
        InternetConnectionState.UNKNOWN
    );

    constructor() {
        super();
        this.createInternetConnectionSubscription();
    }

    get internet$(): Observable<InternetConnectionState> {
        return this._internetSubject;
    }

    waitForInternetConnection(): Observable<void> {
        return this.internet$.pipe(
            filter((state) => state !== InternetConnectionState.OFFLINE),
            take(1),
            map(() => void 0)
        );
    }

    private createInternetConnectionSubscription(): void {
        Network.getStatus().then(({ connectionType }) => {
            this._internetSubject.next(this.toEnum(connectionType));
            this.addNetworkStatusListener();
        });
    }

    private addNetworkStatusListener(): void {
        Network.addListener('networkStatusChange', ({ connectionType }) => {
            this._internetSubject.next(this.toEnum(connectionType));
        });
    }

    private toEnum(state: ConnectionType): InternetConnectionState {
        switch (state) {
            case 'wifi':
                return InternetConnectionState.WIFI;
            case 'cellular':
                return InternetConnectionState.CELLULAR;
            case 'unknown':
                return InternetConnectionState.UNKNOWN;
            case 'none':
                return InternetConnectionState.OFFLINE;
            default:
                return InternetConnectionState.UNKNOWN;
        }
    }
}
